import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'
import { FetchRequest } from '@rails/request.js'
import { useDebounce } from "stimulus-use"

export default class extends Controller {

  static debounces = ['onRemoveFile']
  static targets = [
    "Container", "Background", "Content"
  ]

  connect() {
    this.element[this.identifier] = this
    useDebounce(this)
  }

  initialize() {
    this.open = false
    this.resourceId = null
    this.resourceType = null
  }

  openModal(resourceId, resourceType) {
    if (this.open == false) {
      if (resourceId != this.resourceId || resourceType != this.resourceType) {
        this.resourceId = resourceId
        this.resourceType = resourceType

        this.requestResourceFormContent(resourceId, resourceType)
      }
      this.open = true

      this.ContainerTarget.classList.remove("hidden", "pointer-events-none")
      enter(this.BackgroundTarget)
      enter(this.ContentTarget)
    }
  }

  closeModal(e) {
    e && e.preventDefault()

    if (this.open) {
      leave(this.BackgroundTarget)
      leave(this.ContentTarget)
      setTimeout(() => {
        this.open = false
        this.ContainerTarget.classList.add("hidden", "pointer-events-none")
      }, 300)
    }
  }

  async requestResourceFormContent(resourceId, resourceType) {
    const request = new FetchRequest('get', `/admin/tracking/edit_form?resource_id=${resourceId}&resource_type=${resourceType}`, { responseKind: 'turbo-stream' })
    const response = await request.perform()

    if (response.ok) {
      // do something with response
    }
  }

  onFormSubmit(e) {
    setTimeout(() => {
      this.closeModal()
    })
  }

  onRemoveFile(e) {
    e.preventDefault()
    e.stopPropagation()

    if (window.confirm(e.target.dataset.confirmText)) {
      const request = new FetchRequest(e.target.dataset.method, e.target.dataset.url, { responseKind: 'turbo-stream' })
      request.perform()
    }
  }

}